import { CRUDFabric } from "../CRUDs/CRUDFabric.js";

export default {
    init() {
        this.tasks();
        this.addWorker();
        this.delWorker('tasker__modal-delete-workers');
        this.saveTask('add_tasker_form');
        $('.tasker__modal-wrapper-worker-info-deadline-calendar').datetimepicker({
            format: 'MM/DD/YYYY hh:mm a',
            locale: 'en',
        });
        this.editForm('tasker__wrapper');
        this.deltask();
        this.userCompleteTask();
        this.addUserCompleteTask();
        this.searchTasker();
        this.filterWorker();
        this.selectedWorkerFilter();
        this.unselectedWorkerFilter();
        this.searchWorker();
        this.emailTask();
        this.viewTaskMobile();
        this.mobileTask();
        this.editMobileForm();

    },

    tasks(){
            let tasks = $('.tasker__header-wrapper-button-tasks');

            tasks.click(function (e){
                if (!$(this).hasClass('tasks-select'))
                {
                    tasks.removeClass('tasks-select');
                    $(this).addClass('tasks-select');
                    $('.tasker__body-tasks').toggleClass('d-flex');
                    $('.tasker__body-tasks').toggleClass('d-none');
                }
            });
        },
    mobileTask() {

        let mobileTasks = $('.mobile-tasker__header-wrapper-button-tasks');

        mobileTasks.click(function (e){
            if (!$(this).hasClass('tasks-select'))
            {
                mobileTasks.removeClass('tasks-select');
                $(this).addClass('tasks-select');
                $('.tasker__body-tasks').toggleClass('d-flex');
                $('.tasker__body-tasks').toggleClass('d-none');
            }
        });
    },

    addWorker() {
        $('.assign_workers_modal_btn, .tasker__modal-wrapper-worker-info-add-new').click(function() {
            const current = $(this);
            const entityName = current.data('entity')
            const Entity = CRUDFabric.getClass(entityName);
            const entityObj = new Entity(current.data('id'));
            entityObj.openModal('assing_workers');
            $('#assing_workers-task-modal').addClass('create');
        });

        $('#form-container').on('click', '#assing_workers-task-modal.create #assing_workers', (e) => {
            e.preventDefault();
            this.assingWorkersButtons();
            $('#assing_workers-task-modal').modal('hide');
        })
    },
    assingWorkersButtons(){
        let checkbox = $('.selected-worker');
        $.each(checkbox, function(index, value){
            $('div[data-worker-id="' + $(value).data('id') + '"].tasker__modal-wrapper-worker-info-add-user').removeClass('d-none');
            $('div[data-worker-id="' + $(value).data('id') + '"].tasker__modal-wrapper-worker-info-add-user').addClass('d-flex');
            $('.tasker__modal-wrapper-worker-info-add-acc-link').addClass('d-none');
            $('.tasker__modal-wrapper-worker-info-add-new').removeClass('d-none');
            $('input[type="hidden"][value="' + $(value).data('id') + '"].input_worker').prop('disabled', false);
        });
    },

    delWorker(id = '') {
        if (id == '') return false;

        let workers = $('.tasker__modal-wrapper-worker-info-add-user');
        $('.' + id).click(function (e){
           $(this).parent().removeClass('d-flex');
           $(this).parent().addClass('d-none');
           $('input[data-worker-id="' + $(this).parent().data('worker-id') + '"].tasker__modal-worker-body-wrapper-item-checkbox').prop('checked', false);
            $('input[type="hidden"][value="' + $(this).parent().data('worker-id') + '"].input_worker').prop('disabled', true);
            if (!workers.hasClass('d-flex')){
                $('.tasker__modal-wrapper-worker-info-add-acc-link').removeClass('d-none');
                $('.tasker__modal-wrapper-worker-info-add-new').removeClass('d-flex').addClass('d-none');

            }
        });
    },

    saveTask(id = '') {
        $('#' + id).submit(function(e){
            e.preventDefault();
            let form = $(this);
            $.ajax({
                url: form.attr('action'),
                method: form.attr('method'),
                data: form.serialize(),
                success: function(response){
                    if (response.error == 'email') {
                        $('.modal__alerts-color').removeClass('d-none');
                        $('.tasker__modal-wrapper-worker-info-alerts').addClass('modal__alerts');
                        $('#alerts').addClass('modal__alerts-select');
                    }
                    if (response.status == 'true')
                        window.location.reload();
                },
                error: function(response){
                    if (response.status == '422')
                    {
                        for (let errorKey in response.responseJSON.errors) {
                            switch (errorKey) {
                                case 'workers':
                                    $('.error_workers').removeClass('d-none');
                                    break;
                                case 'deadline':
                                    $('.error_deadline').removeClass('d-none');
                                    break;
                                case 'task_name':
                                    $('.error_task_name').removeClass('d-none');
                                    break;
                            }

                        }
                    }
                }
            })
        });
    },

    openEditWorkerAdd(id = ''){
        if (id == '') return false;
        $('.' + id).click(function (e){
            const current = $(this);
            const entityName = current.data('entity')
            const Entity = CRUDFabric.getClass(entityName);
            const entityObj = new Entity(current.data('id'));
            entityObj.openModal('assing_workers');
        });

        $('body').on('click', '#assing_workers-task-modal:not(.create) #assing_workers', (e) => {
            console.log('тут нажато');
            const form = $(e.target).parents('form');
            const id = form.find('[name=id]').val();
            const entityName = form.data('entity')
            const Entity = CRUDFabric.getClass(entityName);
            const entityObj = new Entity(id);
            this.assingWorkersButtons();
            entityObj.assingWorkers(() => {
                $('.modal-form#assing_workers-task-modal').modal('hide')
            });
        })
    },

    openDeleteTask(id = '') {
        if (id == '') return false;
        $('.' + id).click(function (e){
            $('#deleteTask').modal('show');
        });
    },

    openLogs(id = ''){
        if (id == '') return false;
        $('.' + id).click(function (e){
            $('#logsTask').modal('show');
        });
    },

    emailTask(){
        let _this = this;
        let emailTaskID = $('input[name=editTaskFromEmail]');
        if (emailTaskID.val() != '')
            _this.showEditTaskModal(emailTaskID.val());

    },

    editForm(task = ''){
        if (task == '') return false;
        let _this = this;
        $('.' + task).click(function (e){
            let element = $(this);
            let taskId = element.data('task-id');
            _this.showEditTaskModal(taskId);
        });
    },
    editMobileForm() {
        let _this = this;
        $('.mobile-tasker__view-wrapper-box').click(function (e){
            let element = $(this);
            let taskId = element.data('task-id');
            _this.showEditTaskModal(taskId);
        });
    },

    showEditTaskModal(taskId = '') {
        let _this = this;
        if (taskId == '') return false;
        $.ajax({
            url: '/tasker/get-edit-tasker/' + taskId,
            method: 'GET',
            success: function(res) {
                $('#ajax_modals_container').html(res);
                $('#editTaskerModal').modal('show');
                $('.edit-tasker__modal-wrapper-worker-info-deadline-calendar').datetimepicker({
                    format: 'YYYY-MM-DD hh:mm:ss',
                    locale: 'en',
                });
                _this.delWorker('edit-tasker__modal-delete-workers');
                _this.openEditWorkerAdd('edit-modal__open');
                _this.addWorker('edit-modal__worker-add');
                _this.saveTask('edit_tasker_modal');
                _this.openDeleteTask('tasker__modal-wrapper-worker-info-create-delete');
                _this.openLogs('tasker__modal-wrapper-descr-info-logs');
                _this.delUrlSearch();
                $('.tasker__modal-wrapper-worker-info-deadline-calendar').datetimepicker({
                    format: 'MM/DD/YYYY hh:mm a',
                    locale: 'en',
                });
            }
        });
    },

    deltask(){
        $('.tasker__modal-delete-footer-wrapper-btn-yes').click(function (e){
            $('#deleteTask').modal('hide');
            $('#editTaskerModal').modal('hide');
        });
    },

    userCompleteTask() {
        $('.tasker__complete').click(function (e){
           $('#completeTask').modal('show');
        });
    },

    addUserCompleteTask () {
        $('.tasker__complete').click(function (e){
            let _this = this;
            let element = $(this);
            let taskId = element.data('task-id');
            $('.tasker__modal-complete-footer-wrapper-btn-yes').click(function (e){
                $.ajax({
                    url: '/tasker/change-status/' + taskId,
                    method: 'GET',
                    success: function(res) {
                        window.location.reload();
                    }
                });
            });

        });
    },

    searchTasker() {
        let searchTask = $('#tasker_search');
        searchTask.keydown(function (e){
            if (e.keyCode === 13)
            {
                if (searchTask.val() == 'none')
                {
                    window.location.search = new URLSearchParams().toString();
                    return;
                }
                if('URLSearchParams' in window && searchTask) {
                    let searchParams = new URLSearchParams(window.location.search);
                    searchParams.set('filterTask', searchTask.val());
                    window.location.search = searchParams.toString();
                }
            }
        });
    },

    filterWorker() {
        $('.tasker__header-wrapper-search-arrow').click(function (e){
            $('.tasker__header-wrapper-search-worker-filter').toggleClass('tasker__overflow');
            $('.tasker__header-wrapper-search-arrow').toggleClass('tasker_arrow-deg')
        });
    },

    selectedWorkerFilter () {
        $('.tasker__header-wrapper-search-worker-filter-circle').click(function (e){
            $('.wrapper').addClass('d-none');
            $(this).parent().removeClass('d-none');
            $(this).parent().addClass('selected')
            $('.tasker__header-wrapper-search-worker-filter').addClass('selected')
            $(this).next().removeClass('d-none');
            $('.tasker__header-wrapper-search-arrow').addClass('d-none');
        });
    },

    unselectedWorkerFilter () {
      $('.tasker__header-wrapper-search-worker-filter-circle-descr-img').click(function (e){
          $('.wrapper').removeClass('d-none');
          $(this).parent().addClass('d-none');
          $(this).parent().removeClass('selected')
          $('.tasker__header-wrapper-search-worker-filter').removeClass('selected')
          $(this).next().addClass('d-none');
          window.location.search = new URLSearchParams().toString();
      });
    },

    searchWorker() {
        $('.tasker__header-wrapper-search-worker-filter-circle').click(function (e){
            let searchWorker = $(this).parent().find('input').val();
            if (searchWorker == null)
            {
                window.location.search = new URLSearchParams().toString();
                return;
            }
            if('URLSearchParams' in window && searchWorker) {
                let searchParams = new URLSearchParams(window.location.search);
                searchParams.set('filterWorker', searchWorker);
                window.location.search = searchParams.toString();
            }
        });
    },

    delUrlSearch(){
        $('.tasker__modal-header-close').click(function (e){
            window.location.search = new URLSearchParams().toString();
        });
    },

    viewTaskMobile() {
        $('.mobile-tasker__body-wrapper').click(function (e){
            $(this).next().toggleClass('d-none');
        });
        $('.mobile-tasker__view-wrapper-img-arrow').click(function (e){
            $(this).parent().parent().parent().addClass('d-none')
        });
    },
}


